<template>
  <div data-testid="tab-bar" class="flex flex-row justify-start" :class="gap"><slot></slot></div>
</template>

<script setup lang="ts">
import { provide, useId } from 'vue'

import { TAB_BAR_GROUP_NAME } from './tabBarGroupName'

defineOptions({
  inheritAttrs: false,
})

interface Props {
  gap?: string
}

withDefaults(defineProps<Props>(), {
  gap: 'gap-4',
})

provide(TAB_BAR_GROUP_NAME, useId())
</script>
